import { EasyGuid } from '../utils/easy_guid';
/**
 * The representation of event emitter.
 */
var EventEmitter = /** @class */ (function () {
    /**
     * The default constructor.
     * @param source The source.
     */
    function EventEmitter(source) {
        this.silentMode = 0;
        this.events = new Array();
        this.source = source;
    }
    /**
     * Subscries to the event.
     * @param eventType The event type.
     * @param callback The callback.
     * @returns The subscribtion ID.
     */
    EventEmitter.prototype.subscribe = function (eventType, callback) {
        var event = this.getEventRecByType(eventType);
        var eventCallback = {
            id: EasyGuid.newGuid(),
            callback: callback
        };
        if (event) {
            event.eventCallbacks.push(eventCallback);
        }
        else {
            event = {
                type: eventType,
                eventCallbacks: new Array(eventCallback)
            };
            this.events.push(event);
        }
        return eventCallback.id;
    };
    /**
     * Unsubsribes from the event.
     * @param eventType The event type.
     * @param callbackId The subscribtion ID.
     */
    EventEmitter.prototype.unsubscribe = function (eventType, callbackId) {
        var event = this.getEventRecByType(eventType);
        if (event) {
            var index = -1;
            for (index = 0; index < event.eventCallbacks.length; index++) {
                if (event.eventCallbacks[index].id === callbackId) {
                    break;
                }
            }
            if (index >= 0) {
                event.eventCallbacks.splice(index, 1);
            }
        }
    };
    /**
     * Fires the event.
     * @param eventType The event type.
     * @param data The event data.
     * @param postpone  The postpone.
     * @param force To fire force. If value is `true`, ignores silent mode.
     */
    EventEmitter.prototype.fire = function (eventType, data, postpone, force) {
        if (postpone === void 0) { postpone = 0; }
        if (force === void 0) { force = false; }
        if (this.silentMode && !force) {
            return;
        }
        var eventRec = this.getEventRecByType(eventType);
        if (eventRec) {
            var eqevent_1 = {
                type: eventType,
                source: this.source,
                data: data
            };
            var emitAllFunc = function () {
                for (var _i = 0, _a = eventRec.eventCallbacks; _i < _a.length; _i++) {
                    var callback = _a[_i];
                    callback.callback(eqevent_1);
                }
            };
            if (postpone > 0) {
                setTimeout(emitAllFunc, postpone);
            }
            else {
                emitAllFunc();
            }
        }
    };
    /**
     * Enters to silent mode.
     */
    EventEmitter.prototype.enterSilentMode = function () {
        this.silentMode++;
    };
    /**
     * Exits from silent mode.
     */
    EventEmitter.prototype.exitSilentMode = function () {
        if (this.silentMode) {
            this.silentMode--;
        }
    };
    /**
     * Checks if emitter is in silent mode.
     * @return `true`, if silent mode is enable.
     */
    EventEmitter.prototype.isSilent = function () {
        return this.silentMode > 0;
    };
    EventEmitter.prototype.getEventRecByType = function (eventType) {
        for (var _i = 0, _a = this.events; _i < _a.length; _i++) {
            var event_1 = _a[_i];
            if (event_1.type == eventType) {
                return event_1;
            }
        }
        return null;
    };
    return EventEmitter;
}());
export { EventEmitter };
//# sourceMappingURL=event_emitter.js.map